import React from "react";
import { useSelector } from "react-redux";
import { RuvnlTitle } from "../components";

import Hamburger from "../../../components/Hamburger";
import { ReactComponent as GNAiIcon } from "../../../icons/gnai_logo.svg";
import { TabSwitcher } from "../Raj_Dashboard";
import { PageHeader } from "../../../components/Page";
import { ReactComponent as Session } from "../../../icons/Session_icon.svg";
import { ReactComponent as Target } from "../../../icons/target_date_icon.svg";
interface SessionInfoProps {
  modSessionToken?: string;
  selectDate?: string;
}

const SessionInfo: React.FC<SessionInfoProps> = () => {
  const preSelectedDate = useSelector(
    (state: any) => state.modDemoDate.selectedDate
  );
  const modSessionToken = useSelector(
    (state: any) => state.modDemoSessionToken.modSessionToken
  );
  const formatDateWithSuffix = (dateString: string): string => {
    const date = new Date(dateString);
    const day = date.getDate();
    const year = date.getFullYear();

    const month = date.toLocaleString("default", { month: "long" });

    // Add suffix to the day (1st, 2nd, 3rd, etc.)
    const getDayWithSuffix = (d: number): string => {
      if (d > 3 && d < 21) return `${d}th`;
      switch (d % 10) {
        case 1:
          return `${d}st`;
        case 2:
          return `${d}nd`;
        case 3:
          return `${d}rd`;
        default:
          return `${d}th`;
      }
    };

    return `${getDayWithSuffix(day)} ${month} ${year}`;
  };
  const TargetDate = formatDateWithSuffix(preSelectedDate);
  return (
    <PageHeader
      leftComponent={
        <div className="flex flex-row md:gap-x-4 gap-x-2 items-center">
          <GNAiIcon width={80} />
          <Hamburger />
          <TabSwitcher />
          <h1 className="text-[18px] text-[#6F6D7C]">
            MeritEngine
          </h1>
        </div>
      }
      middleComponent={<RuvnlTitle />}
      rightComponent={
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2">
            <Session className="w-7 h-7" />
            <div className="flex-1 text-start">
              <p className="text-xs text-[#F1935C] font-medium">Session ID</p>
              <p className="text-xs font-medium text-[#6F6D7C]">
                {modSessionToken}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Target className="w-7 h-7" />
            <div className="flex-1 text-start">
              <p className="text-xs text-[#34656D] font-medium">Target Date</p>
              <p className="text-xs font-medium text-[#6F6D7C]">{TargetDate}</p>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default SessionInfo;
